import Component from 'navigation/component/Component';
import config from 'core/config';
import sizeStore from 'store/sizeStore';
import { bindMethod } from 'helpers/bind';
import anime from 'animejs';
import { EASE_OUT, frameToMs } from 'helpers/easings';
import store from 'store/store';
import { startPanels } from 'store/middlewares/panels';
class Header extends Component {
    motions = [];
    constructor(el, options) {
        super(el, options);
        this.resize();
    }
    bindEvents(add = true) {
        const method = bindMethod(add);
        store.cart.toggleListener(add, this.onCartUpdate);
        store.logged.toggleListener(add, this.onLoginStatusUpdate);
        store.alternateLinks.toggleListener(add, this.onAlternateLinkUpdate);
        store.drawer.toggleListener(add, (drawer, previous) => this.onDrawerChange(drawer, previous));
        this.refs.headerSearchButton.forEach(btn => btn[method]('click', this.onHeaderSearchClicked));
        this.refs.headerMenuButton[method]('click', this.onMenuClicked);
        this.bindInternalRouter();
    }
    show() {
        this.el.classList.add('shown');
        startPanels();
    }
    bindRefs() {
        super.bindRefs();
    }
    onCartUpdate = (count) => {
        this.refs.headerCart.setAttribute('data-count', count);
        this.refs.headerCart.classList.toggle('header-right__cart-not-empty', count !== 0);
    };
    onAlternateLinkUpdate = (links = {}) => {
        if (!this.refs.headerAlternateLinks)
            return;
        this.refs.headerAlternateLinks.forEach(link => {
            const lang = link.getAttribute('data-lang');
            const href = links[lang];
            if (href)
                link.setAttribute('href', href);
            else
                link.setAttribute('href', config.baseurl + '/' + lang);
        });
    };
    onLoginStatusUpdate = (logged) => {
        this.el.classList.toggle('logged', logged);
    };
    onMenuClicked = (e) => {
        if (store.search.get())
            store.search.set(null);
        const drawer = store.drawer.get();
        store.drawer.set(drawer === 'menu' ? null : 'menu');
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();
    };
    onDrawerChange = (value, previous) => {
        const isOpen = value === 'menu';
        if (!isOpen && previous !== 'menu')
            return;
        this.cancelMotions();
        if (isOpen)
            this.setMenuIconOpened();
        else
            this.setMenuIconClosed();
    };
    setMenuIconClosed() {
        const bar = this.refs.headerMenuButton.querySelector('svg line:first-child');
        const secondBar = this.refs.headerMenuButton.querySelector('svg line:last-child');
        let m, m1, m2, m3;
        const opened = {
            first: {
                x1: 10,
                y1: 13,
                x2: 22,
                y2: 13
            },
            second: {
                x1: 10,
                y1: 19,
                x2: 22,
                y2: 19
            }
        };
        m = anime({
            targets: secondBar,
            x1: opened.second.x2,
            y1: opened.second.y2,
            x2: opened.second.x1,
            y2: opened.second.y1,
            easing: EASE_OUT,
            duration: frameToMs(25),
            delay: frameToMs(10)
        });
        m1 = anime({
            targets: bar,
            x1: opened.first.x1,
            y1: opened.first.y1,
            x2: opened.first.x2,
            y2: opened.first.y2,
            easing: EASE_OUT,
            duration: frameToMs(25),
            delay: frameToMs(10)
        });
        m2 = anime({
            targets: this.refs.headerMenuOpenText,
            opacity: 1,
            translateX: 0,
            easing: EASE_OUT,
            duration: frameToMs(25),
            delay: frameToMs(10)
            // delay: isOpen ? 0 : frameToMs(50 / 2)
        });
        m3 = anime({
            targets: this.refs.headerMenuCloseText,
            opacity: 0,
            translateX: '-30%',
            easing: EASE_OUT,
            duration: frameToMs(25),
            delay: frameToMs(10)
        });
        this.motions.push(m, m1, m2, m3);
    }
    setMenuIconOpened() {
        const bar = this.refs.headerMenuButton.querySelector('svg line:first-child');
        const secondBar = this.refs.headerMenuButton.querySelector('svg line:last-child');
        let m, m1, m2, m3;
        const closed = {
            first: {
                x1: 12.1,
                y1: 11.9,
                x2: 20.6,
                y2: 21.1
            },
            second: {
                x1: 20.6,
                y1: 11.9,
                x2: 12.1,
                y2: 21.1
            }
        };
        m = anime({
            targets: secondBar,
            x1: closed.second.x1,
            y1: closed.second.y1,
            x2: closed.second.x2,
            y2: closed.second.y2,
            easing: EASE_OUT,
            duration: frameToMs(25)
        });
        m1 = anime({
            targets: bar,
            x1: closed.first.x1,
            y1: closed.first.y1,
            x2: closed.first.x2,
            y2: closed.first.y2,
            easing: EASE_OUT,
            duration: frameToMs(25)
        });
        m2 = anime({
            targets: this.refs.headerMenuOpenText,
            opacity: 0,
            translateX: '30%',
            easing: EASE_OUT,
            duration: frameToMs(25)
            // delay: isOpen ? 0 : frameToMs(50 / 2)
        });
        m3 = anime({
            targets: this.refs.headerMenuCloseText,
            opacity: 1,
            translateX: 0,
            easing: EASE_OUT,
            duration: frameToMs(25)
        });
        this.motions.push(m, m1, m2, m3);
    }
    onHeaderSearchClicked = async () => {
        store.drawer.set(store.drawer.get() === 'search' ? null : 'search');
        document.querySelector('.search__inner input').focus();
    };
    onScroll = () => {
        sizeStore.headerBottom.set(this.el.offsetTop + this.el.offsetHeight);
    };
    resize() {
        const height = this.el.offsetHeight;
        sizeStore.headerHeight.set(height);
    }
    cancelMotions() {
        this.motions.forEach(m => m.pause());
        this.motions = [];
    }
}
export default Header;
